export default "__VITE_ASSET__D1tcrMB1__"